<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="globe"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <client-select :model="filterFormModel" attribute="client" class="mr-1 mb-1"></client-select>
            <form-input :model="filterFormModel" attribute="brandName" class="mr-1 mb-1" :placeholder="$t('brandNameInput')"></form-input>
            <time-range-picker :model="filterFormModel" class="mr-1 mb-1" :label="$t('createTime')"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>

            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('client') }}</div>
            <div class="col-lg-3">Brand name</div>
            <div class="col-lg-3">{{ $t('amount') }}</div>
            <div class="col-lg-3">{{ $t('createTime') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <b class="c-smart-table__label">{{ $t('client') }}: </b>
              <span>{{ item.client.companyName }} ({{ item.client.domain }})</span>
            </div>
            <div class="col-lg-3">
              <p >
                <b class="c-smart-table__label">Brand name:&nbsp;</b>
                <span>{{ item.brandName.name }}</span>
              </p>
            </div>
            <div class="col-lg-3">
              <p >
                <b class="c-smart-table__label">{{ $t('amount') }}:&nbsp;</b>
                <span>{{ item.amount | numFormat }}</span>
              </p>
            </div>
            <div class="col-lg-3">
              <p>
                <b class="c-smart-table__label">{{ $t('createTime') }}: </b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from "@/mixins/List";
import ClientSelect from "../../components/ClientSelect";
import _ from 'lodash';
import TimeRangePicker from "@/components/TimeRangePicker";

export default {
  components: {
    TimeRangePicker,
    ClientSelect
  },
  mixins: [List],
  data: function () {
    return {
      service: '/sms-brand-name-register-transaction',
      autoLoad: true,
      defaultFilterFormModel: {
        client: null,
        brandName: null,
      },
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
  },
  i18n: {
    messages: {
      en: {
        title: 'SMS brand name register transaction',
        createTime: 'Create time',
        amount: 'Amount',
        brandNameInput: 'Brand name input'
      },
      vi: {
        title: 'Phí đăng ký tên định danh SMS brand name',
        createTime: 'Tính tiền lúc',
        amount: 'Số tiền',
        brandNameInput: 'Nhập brand name'
      }
    }
  }
}
</script>